// extracted by mini-css-extract-plugin
export default {"card":"card_card__1gnXC","light":"card_light__XKbkK","dark":"card_dark__Ai0hS","error":"card_error__7lWGq"};